import script from "./ListInvoiceProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./ListInvoiceProxy.vue?vue&type=script&setup=true&lang=js"

import "./ListInvoiceProxy.vue?vue&type=style&index=0&id=7aada0b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aada0b6"]])

export default __exports__